

export const notification_settings_permissions ={
    required_permission:['add_notificationsettings','change_notificationsettings',"view_notificationsettings"],
}
